import React from "react";
import { Helmet } from "react-helmet";

function AccessibilityPage() {
    return (
        <div className={"Barrierefreiheitserklarung Rechtliches"}>
            <Helmet>
                <title>Barrierefreiheitserklarung | FIRMENRADL</title>
                <meta
                    name="description"
                    content="Wir setzen uns für digitale Barrierefreiheit ein. Erfahre, wie FIRMENRADL seine Website gemäß EU-Richtlinien zugänglich gestaltet und wie du Barrieren melden kannst."
                />
                <meta name="robots" content="noindex, nofollow" />
                <meta name="theme-color" content="#E0334C" />
            </Helmet>
            <div className="fr-view u-clearfix u-rich-text u-text u-text-3">
                <h2>Barrierefreiheitserklärung</h2>
                <p>Wir möchten, dass sich alle Menschen auf unserer Website gut zurechtfinden – unabhängig von körperlichen oder technischen Voraussetzungen. Deshalb arbeiten wir daran, unseren Online-Plattform so barrierefrei wie möglich zu gestalten.</p>
                <p>Diese Erklärung gilt für die Website <a href="www.firmenradl.at ">www.firmenradl.at</a>.</p>
                <hr />
                <h2>Wie barrierefrei ist die Seite aktuell?</h2>
                <p>Unsere Website ist <strong>teilweise barrierefrei</strong>. Das bedeutet: Viele Inhalte erfüllen bereits die Anforderungen der Web Content Accessibility Guidelines (WCAG) 2.1 auf Stufe AA – einige noch nicht.</p>
                <hr />
                <h2>Welche Inhalte sind (noch) nicht barrierefrei?</h2>
                <p>Aktuell gibt es noch einzelne Stellen, an denen du möglicherweise Einschränkungen bemerkst.</p>
                {/* <ul>
                    <li>tbd.</li>
                </ul>  */}
                <p>Wir arbeiten laufend daran, diese Punkte zu verbessern.</p>
                <hr />
                <h2>Stand der Erklärung</h2>
                <p>Diese Erklärung wurde am <strong>30.06.2025</strong> erstellt und zuletzt am <strong>30.06.2025</strong> geprüft. Die Bewertung erfolgte durch  eine Selbstprüfung.</p>
                <hr />
                <h2>📣 Du hast eine Barriere entdeckt? Sag uns Bescheid!</h2>
                <p>Wenn dir eine Barriere auffällt oder du Inhalte brauchst, die du nicht zugänglich nutzen kannst – melde dich bei uns:</p>
                <p><strong>E-Mail:</strong> <a href="mailto:barrierefrei@intersport.at">barrierefrei@intersport.at</a></p>
                <p>Wir freuen uns über dein Feedback und finden gemeinsam eine Lösung.</p>
                <hr />
                <h2>Was tun, wenn du keine Antwort bekommst?</h2>
                <p>Solltest du mit unserer Rückmeldung nicht zufrieden sein, hast du das Recht, dich an die offizielle Stelle zu wenden:</p>
                <p><strong>Österreichische Ombudsstelle für barrierefreies Internet</strong></p>
                <p><a href="https://www.behindertenanwalt.gv.at">https://www.behindertenanwalt.gv.at</a></p>
            </div>
        </div>
    );
}

export default AccessibilityPage;
